export class Image {
  public id: string;

  constructor(imageId: string) {
    this.id = imageId;
  }
}
